module.exports = __webpack_public_path__ + "img/signin_people_blue.8c6b5bc5.svg";